import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEsLocale from 'element-ui/lib/locale/lang/es' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import esLocale from './es'
import zhLocale from './zh'
// import AvueZhLocale from '@smallwei/avue/lib/locale/lang/zh'
// import AvueEnLocale from '@smallwei/avue/lib/locale/lang/en'
Vue.use(VueI18n)

const messages = {
  es: {
    ...esLocale,
    ...elementEsLocale,
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale,
  }
}
export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js